import React from "react";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";
import "./QuestionPaperArchives.scss";

function QuestionPapersArchive() {
  return (
    <>
      <SectionTitle2 title="Question Papers Archive" />

      <div className="qp-links">
        <a href="/QuestionPapers" className="qp-card">
          Law Question Papers
        </a>
        <a href="/QuestionPapernonlaw" className="qp-card">
          Non-Law Question Papers
        </a>
      </div>
    </>
  );
}

export default QuestionPapersArchive;
